import { render } from "./collapse.vue?vue&type=template&id=25df84fc&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=25df84fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25df84fc"

export default script